import { Component, inject, signal } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { TranslatePipe } from '@ngx-translate/core';
import { format, parse } from 'date-fns';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { JsonPipe } from '@angular/common';

@Component({
  selector: 'app-date-range-modal',
  imports: [FormsModule, ReactiveFormsModule, BsDatepickerModule, TranslatePipe],
  templateUrl: './date-range-modal.component.html',
  styleUrl: './date-range-modal.component.scss'
})
export class DateRangeModalComponent {
  private formBuilder = inject(FormBuilder);

    bsModalRef = inject(BsModalRef);
    modalService = inject(BsModalService);
    data: { dateInit: Date; dateEnd: Date };

    submitAttempted = signal<any>(false);
    form!: FormGroup;

    public startMinDate!: Date;
    public startMaxDate: Date;
    public endMinDate!: Date;
    public endMaxDate: Date;

    public bsConfig = {
      dateInputFormat: 'DD/MM/YYYY',
      showWeekNumbers: false,
      adaptivePosition: true,
    };

    ngOnInit(): void {

        this.form = this.formBuilder.group({
            dateInit: [this.data?.dateInit || null, [Validators.required]],
            dateEnd: [this.data?.dateEnd || null, [Validators.required]],
        });

        this.form.valueChanges.subscribe((values) => {
            const { dateInit, dateEnd } = values;
            const newStartMaxDate = dateEnd ? dateEnd : null;
            const newEndMinDate = dateInit ? dateInit : null;
            this.startMaxDate = newStartMaxDate ? newStartMaxDate: null;
            this.endMinDate = newEndMinDate;
        });
    }

    setValues() {
        this.submitAttempted.set(true);
        if (!this.form.valid) {
            return;
        }
        this.modalService.setDismissReason(this.form.value);
        this.bsModalRef.hide();
    }
}
